<template>
	<div class="pr-5 pl-5 pt-3 page-fill">
		<div class="row w-full mb-3 justify-between flex" style="align-items: center">
			<h1>Systems</h1>
			<div class="cardbody">
				<div class="flex flex-row-reverse items-center">
					<div class="flex flex-row-reverse items-center gap-3">
						<button class="flex" @click="filterOpen" :class="tableRow.length == 0 ? 'filterButtondisabled pointer-events-none' : 'filterButton'">
							<img  v-if="tableRow.length == 0" src="@/assets/filterIcon_Disabled.svg" class="filterIcon"/>
							<img v-else src="@/assets/filter.svg" class="filterIcon" />
							Filters
						</button>
					</div>
				</div>
			</div>
		</div>
        <div class="mt-3">
            <p class="headerText">
            Data Oragnisation is the practice of categorizing and classifyinf data to make it more usable.Similar to a file folder,where we keep important documents ,you'll need to arrange your data in the most logical and orderly fashion ,so you -- and anyone else who accesses it -- can easily find what they're looking for .Data organization is the practice  of categorizing and classifying data to make it more usable. Similar to a file folder, when we keep important documents,you'll need to arrange your data in the most logical and orderly fashion.
            </p>
        </div>
		<div class="mt-5 table-section">
			<tableData class="flex-1 min-h-0" :tableRowData="tableRow" :headersData="headers" :tableRouteArr="optionsValue" :loadData="dataLoading"></tableData>
			<div v-if="toolTipActive">
				<tool-tip :tipText="toolTipText"></tool-tip>
			</div>
		</div>
		<popup v-if="showActivityPopup" :popUp="showActivityPopup">
				<template v-slot:header>
					<div class="flex items-center justify-between py-4 px-2 rounded">
						<h1 class="pl-2">System</h1>
						<button class="float-right text-3xl" @click="onCancelbtn()">
							<img src="@/assets/cancel.svg" class="h-5 w-5 cursor-pointer" />
						</button>
					</div>
				</template>
				<fieldset>
					<div>
						
						<div>
							<div class="statuscontainer popupbodycontainer">
								<div class="formcontainer flex flex-col">
									<div class="row flex flex-row w-full">
										<div class="row flex flex-row w-full">
											<div class="w-6/12">
												<label class="text-xs font-extrabold">System</label>
												<div class="mb-3 mt-2 text-sm">{{ activityObj?.systemName || 'N/A'}}</div>
											</div>
											<div class="w-3/6 leftspacing">
												<label class="text-xs font-extrabold">Category</label>
												<div class="mb-3 mt-2 text-sm">{{ activityObj?.sytemCategory || 'N/A'}}</div>
											</div>
										</div>
									</div>
									<!-- criticality -->
									<div class="row flex flex-row w-full">
										<div class="w-6/12">
											<label class="text-xs font-extrabold">Vendor</label>
											<div class="mb-3 mt-2 text-sm">{{ activityObj?.vendor || 'N/A'}}</div>
										</div>
										<div class="w-3/6 leftspacing">
											<label class="text-xs font-extrabold">Vendor Category</label>
											<div class="mb-3 mt-2 text-sm">{{ activityObj?.vendorCategory || 'N/A' }}</div>
										</div>
									</div>
									<div class="row flex flex-row w-full">
										<div class="w-3/6">
											<label class="text-xs font-extrabold">Model</label>
											<div class="mb-3 mt-2 text-sm">{{ activityObj?.model || 'N/A' }}</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</fieldset>
			</popup>
		
	</div>
</template>
<style scoped>
</style>
<script lang="ts">
import { emitter, toast } from '@/main';
import { defineComponent } from 'vue';
import useVuelidate from '@vuelidate/core';
import tableData from '@/components/tableData.vue';
import popup from '@/components/popup.vue';
import toolTip from '@/components/toolTip.vue';
// import loader from '@/components/loader.vue';
export default defineComponent({
	data(): any {
		return {
			headers:['systemName','sytemCategory','model','vendorCategory','vendor','no.of controls'],

			v$: useVuelidate(),
			departmentsList: [],
			tableRow: [],
			activityObj: {},
			orgUsersList: [],
			optionsUserArray: [],
			controlsCountList: [],
			columnObject: false,
			showActivityPopup: false,
			showLoader: false,
			showFilters: false,
			criticalityArray: [
				{ label: 'Very Low', id: 1 },
				{ label: 'Low', id: 2 },
				{ label: 'Moderate', id: 3 },
				{ label: 'High', id: 4 },
				{ label: 'Critical', id: 5 }
			],
			toolTipActive : false,
			toolTipText : '',
			optionsValue: [
				{
					id: 1,
					value: 'Select',
					route: '/departmentControls',
					presentRoute: '/org/controls/controlMapping'
				}
			], 
			dataLoading:true,
      systems:[],
      vendorList:[],
	  systemVendors:[],
	  matchedVendor:[]
		};
	},
	components: {
		tableData,
		// loader,
		popup,
		toolTip
	},
	mounted() {
		// this.dataLoading = false;
		for (const row of this.tableRow) {
			for (const value of Object.values(row)) {
				if (value == '') {
					this.columnObject = true;
				} else {
					this.columnObject = false;
				}
			}
		}
		emitter.off('controlMappingData')
        emitter.on("controlMappingData", (isData: any) => {
			let comingId = isData.entityData._id;
			this.showEditPopUp(isData.entityData);
        });
		emitter.off('activiteToolTip');
		emitter.on('activiteToolTip', (data: any) => {
			this.toolTipActive = true;
			this.toolTipText = data.tipText
		});
		emitter.off('deActiviteToolTip');
		emitter.on('deActiviteToolTip', (data: any) => {
			this.toolTipActive = false;
			this.toolTipText = ''
		});
	},
	methods: {
		filterOpen() {
			if(this.columnObject == false){
				this.showFilters = !this.showFilters;
				emitter.emit('visible', this.showFilters);
			}
		},
		onCancelbtn() {
			this.v$.$reset();
			this.showActivityPopup = false;
			this.activityObj = {}
		},
		showEditPopUp(obj: any) {
        //    this.$router.push({ name: 'departmentControls', params: { id:  obj._id } });
			this.showActivityPopup = true;
			// let a = this.criticalityArray.find((value: any)=>{return obj.criticality== value.id}).label;
			let owner = this.optionsUserArray.find((user: any) => user.value === obj.teamOwner || obj.globalHead==user.value)?.label || 'N/A';
			this.activityObj = {...obj}
			// this.activityObj.teamOwner = owner
		},
    // 	async getAllVendors(){
    //     // this.vendorCategoryDisplayList = [];
    //     this.vendorList = [];
    //     // this.vendorLabelList = []
    //     try{
	// 		this.showLoader=true;
    //         await this.$http
    //             .get(`${process.env.VUE_APP_ORG_API_URL}/api/org/getall/20003`)
    //             .then((response: any) => {
                    
    //                 let arr:any = response.data;
    //                 this.vendorList = arr


	// 				if(this.vendorList.length > 0) {
	// 					for(let i=0;i<this.vendorList.length;i++) {							
	// 						this.systemVendors.push({_id:this.vendorList[i]._id,name:this.vendorList[i].displayName,vendorCategory:this.vendorList[i].vendorCategory})							
	// 					}
	// 				}
    //                 // this.vendorList = [];

    //                 // arr.map((item:any)=>{
    //                 //     this.vendorCategoryDisplayList.push(item.vendorCategory);
    //                 //     let a = {value:item._id,label:item.name};
    //                 //     this.vendorLabelList.push(a)
    //                 // })
    //             })

    //     } catch(error: any) {
    //         toast.error('Error', {
    //           timeout: 1000,
    //           closeOnClick: true,
    //           closeButton: 'button',
    //           icon: true
    //         });
    //     };
	// 	this.showLoader=false;
    // },
	async fetchSystemsList() {
			try {
				this.showLoader = true;
				this.tableRow = [];
				await this.$http.get(`${process.env.VUE_APP_CONTROLS_API}/api/org/systems/mappedcontrols/count`).then((res: any) => {
					this.systems = res.data;
					this.systems.map((data:any)=>{
                // headers:['systemName','category','model','vendorCategory','vendor','no.of controls'],
                let vendor:any = this.vendorList.find((obj:any)=>{ return obj._id == data.vendor})
                let lengthofMappedControls:any
                let category:any
                let model:any

                if(Object.keys(data).includes('mappedControls')){
                    lengthofMappedControls = data.mappedControls.length
                } else {
                    lengthofMappedControls = 0
                }

                if(Object.keys(data).includes('hostingType')){
                  model = data.hostingType
                } else {
                  model = "N/A"
                }

				this.matchedVendor.push(data.hostingProvider);				
				if(this.systemVendors.length>0) {
					for(let i=0;i<this.systemVendors.length;i++) {
							if(data.vendor == this.systemVendors[i]._id) {
							data.hostingProvider = this.systemVendors[i].name;
							data.vendorCategory = this.systemVendors[i].vendorCategory;
						}
					}
				}

                let obj:any = {
                    _id:data._id,
                    systemName: data.systemName != undefined && data.systemName != '' ? data.systemName : 'N/A',

                    sytemCategory: data.systemCategory != undefined && data.systemCategory != '' ? data.systemCategory : 'N/A',

                    model:data.hostingType != undefined && data.hostingType != '' ? model : 'N/A',

                    vendorCategory: data.vendorCategory != '' && data.vendorCategory != undefined ? data.vendorCategory : 'N/A',

                    vendor:data.hostingProvider != undefined && data.hostingProvider != '' ? data.hostingProvider : 'N/A',

                    "no.of controls":data.controlCount?data.controlCount:0,
                }
                this.tableRow.push(obj)
				this.dataLoading=false;
            })
				});
			} catch (e) {
				toast.error('error', {
					timeout: 1000,
					closeOnClick: true,
					closeButton: 'button',
					icon: true
				});
			}
			this.showLoader = false;
		},
	},
	async created() {
		this.dataLoading = true;
        // await this.getAllVendors()
		await this.fetchSystemsList();
        // await this.getAllSystems();
	}
});
</script>

